import React from "react";
import { Card, Col, Row, Statistic, Spin, List, Typography } from "antd";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";

interface ProduceStatsProps {
  data: {
    totalProduces: number;
    totalAmountUSD: number;
    produces: { name: string; residue: number }[];
  } | null;
  loading: boolean;
}

export default function ProduceStats({ data, loading }: ProduceStatsProps) {
  const { authState } = useAuth();
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      {authState.user?.role !== UserRole.Foreman && (
        <>
          <h2>Продукция Статистика</h2>
          <Row gutter={16}>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Кол-во продукций"
                  value={data.totalProduces}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Общая сумма (USD)"
                  value={roundToThreeDecimals(data.totalAmountUSD)}
                  prefix="$"
                />
              </Card>
            </Col>
          </Row>
        </>
      )}

      <h3>Список материалов ниже лимита:</h3>
      <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
        <List
          dataSource={data.produces}
          renderItem={(item) => (
            <List.Item>
              <Card style={{ width: "100%", background: "red" }}>
                <Typography.Text strong style={{ color: "#fff" }}>
                  {item.name}
                </Typography.Text>
                <div style={{ color: "#fff" }}>
                  Остаток: {roundToThreeDecimals(item.residue)}
                </div>
              </Card>
            </List.Item>
          )}
        />
      </div>
    </div>
  );
}
